import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthenticationService {
    public api_token: string;

    constructor(private http: Http) {  }

    login(id: string , password: string): Observable<boolean> {
        return this.http.post('login', JSON.stringify({ id: id, password: password }))
            .map((response: Response) => {
              const user = response.json();
                if(user && user.token && (user.two_factor_authentication === 1||user.two_factor_authentication === 2)){
                    user.api_token = user.token;
                    localStorage.setItem('tempUser', JSON.stringify(user));
                }else if (user && user.token && user.two_factor_authentication === 0 ) {
                user.api_token = user.token;
                localStorage.setItem('currentUser', JSON.stringify(user));
              }
              return user;
            });
    }

    logout(api_token:string = ''){
      return this.http.get('logout?token=' + api_token).map((response: Response) => response.json());
      // window.location.href = '/#/pages/login';
      // window.location.href = '/#/pages';
    }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts